import { ACTIVITY, ANALYTICS_TABS_PATH } from '../constants'

export const getSubOptionScreen = ({ subtabScreenName, selectedTab }) => {
  return {
    screenName: subtabScreenName,
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_TABS_PATH[selectedTab]
  }
}
